import React from 'react';
import { Text } from './Text';

interface SwitchProps {
  value: boolean;
  onChange: (value: boolean) => void;
  label?: string;
  activeColor?: string;
  inactiveColor?: string;
}

export const Switch: React.FC<SwitchProps> = ({
  value,
  onChange,
  label,
  activeColor = '#ef4444',
  inactiveColor = '#d1d5db'
}) => {
  const switchElement = (
    <div
      onClick={() => onChange(!value)}
      style={{
        width: '32px',
        height: '18px',
        backgroundColor: value ? activeColor : inactiveColor,
        borderRadius: '9px',
        position: 'relative',
        cursor: 'pointer',
        transition: 'background-color 0.2s'
      }}
    >
      <div
        style={{
          width: '14px',
          height: '14px',
          backgroundColor: '#ffffff',
          borderRadius: '50%',
          position: 'absolute',
          top: '2px',
          left: value ? '16px' : '2px',
          transition: 'left 0.2s'
        }}
      />
    </div>
  );

  if (!label) {
    return switchElement;
  }

  return (
    <div
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '8px'
      }}
    >
      <Text variant='body2-medium'>{label}</Text>
      {switchElement}
    </div>
  );
};
